import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { TransferState, makeStateKey } from '@angular/core';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

// services
import { SessionService } from '../../../shared/services/session.service';
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { AppLoaderService } from '../../../shared/services/app-loader.service';

// models
import { AppState } from '../../../booking/models/app-state.interface';

const TOKEN_DATA = makeStateKey('token_data');
const SESSION_ID = makeStateKey('session_id');

@Component({
  selector: 'app-verify-section',
  templateUrl: './verify-section.component.html',
  styleUrls: ['./verify-section.component.scss'],
})
export class VerifySectionComponent implements OnInit, OnDestroy {

  private _tokenStoreData: any;
  private _tokenDataSubscription: Subscription;
  private _sessionDataSubscription: Subscription;
  private _verifyEmailSubscription: Subscription;
  private _userOTPSubscription: Subscription;
  private _dataSavedSubscription: Subscription;
  private _sessionId = null;

  public showLoader = false;
  public userEmail: string;
  public userHasDetails: boolean = false;

  constructor(
    private _appStore: Store<AppState>,
    private _appLoaderService: AppLoaderService,
    private _sessionService: SessionService,
    private _loginService: LoginService,
    private _errorService: ErrorHandler,
    private _dataStorageService: DataStorageService,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _serverState: TransferState,
  ) { }

  ngOnInit() {

    if (isPlatformServer(this.platformId)) {
      this._tokenDataSubscription = this._sessionService.tokenDataReturned$
        .subscribe(hasData => {
          if (hasData === true) {
            const tokenData: any = this._sessionService.getQueryTokenData();
            this._serverState.set(TOKEN_DATA, tokenData as any);
          }
        });
      this._sessionDataSubscription = this._sessionService.sessionDataReturned$
        .subscribe(hasData => {
          if (hasData === true) {
            const sessionId: string = this._sessionService.getQuerySessionId();
            this._serverState.set(SESSION_ID, sessionId as any);
          }
        });
    } else {
      this._appLoaderService.showLoader();
      // global loader show
      this.setSubscriptions();
      try {

        const tokenData = this._serverState.get(TOKEN_DATA, null as any);
        this._sessionId = this._serverState.get(SESSION_ID, null as any);

        // if error returned
        if (tokenData.hasError) {
          this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL_TOKEN_VALID', payload: false });
          this._errorService.handleError(tokenData.data);

          if (tokenData.email) {
            // TODO: : autoLogin
            this.showLoader = true;
            this.userEmail = tokenData.email;
            this._loginService.checkEmail(this.userEmail);
            return;
          }

          setTimeout(() => {
            // redirect with session data
            this._router.routeReuseStrategy.shouldReuseRoute = function(){ return false; };
            const currentUrl = this._router.url;
            this._router.navigateByUrl(currentUrl)
              .then(() => {
                this._router.navigated = false;
                this._appLoaderService.hideLoader();
                window.open('flight-finder/search?session=' + this._sessionId, '_self');
              });
          }, 1500);

        } else {
          console.log('Session data', tokenData);
          this._tokenStoreData = tokenData.data.tokenData || {};
          this._tokenStoreData.token = tokenData.data.urlToken;
          this._tokenStoreData.email = tokenData.data.urlEmail;
          this._tokenStoreData.accessToken = tokenData.data.token;
          try {
            // TODO: OTP verification
            const parsedToken = this.parseReturnedData(this._tokenStoreData.accessToken);
            console.log('OTP TOKEN',parsedToken, this._tokenStoreData.accessToken);
            if (parsedToken.access_token) {
              this.loginUserWithOtpResponse(this._tokenStoreData.accessToken);
              return;
            }
          } catch (e) {
            console.error(e);
          }
          this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL_TOKEN', payload: this._tokenStoreData });
          this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL_TOKEN_VALID', payload: true });

          this._appLoaderService.hideLoader();
          this.redirectUser();
        }
      } catch (err) {
        console.log('IN CATCH');
        this._router.navigate(['flight-finder/search'], {queryParams: {'start-booking': true}});
      }
    }

  }

  setSubscriptions() {
    this._verifyEmailSubscription = this._loginService.verifyUserSubject$
      .subscribe(res => {

        this.showLoader = false;
        this._appLoaderService.hideLoader();

        this._appStore.dispatch({ type: 'UPDATE_USER_STATUS', payload: res.verifyCustomerStatus });
        this._appStore.dispatch({ type: 'UPDATE_USER_HAS_ACCOUNT_DETAILS', payload: Boolean(res.userData.firstName) && Boolean(res.userData.lastName ) });

        // response codes
        // Active = 1, Inactive = 2, NotFound = 3
        if (res.verifyCustomerStatus === 1) {
          // full user
          this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL', payload: this.userEmail });
          this._appStore.dispatch({ type: 'UPDATE_USER_HAS_PASSWORD', payload: Boolean(res.userData.passwordLastResetDatetimeUTC) });

          if(res.userData.userLoginStatus === 2){
            this._router.navigate(['validate-email']);
          } else {
            if(res.userData.is2FARequired) {
              this._router.navigate(['access-account']);
            }else {
              this._router.navigate(['access-options']);
            }
          }

        } else if (res.verifyCustomerStatus === 2 || res.verifyCustomerStatus === 3) {
          this._appStore.dispatch({ type: 'UPDATE_USER_EMAIL', payload: this.userEmail });
          this._appStore.dispatch({ type: 'UPDATE_USER_HAS_PASSWORD', payload: false });

          this._router.navigate(['validate-email']);
        }
      });


      this._userOTPSubscription = this._loginService.userSubject$
      .subscribe(user => {
        this._appLoaderService.hideLoader();

        if (user.error) {
          this.handleError();
          return;
        }
        if (user) {
          this.userHasDetails = Boolean(user.user.firstName);
          this._appStore.dispatch({ type: 'USER_ACCOUNT_UPDATE_STATUS', payload: !this.userHasDetails });

          // save data and resirect
          this._dataStorageService.saveData();
        }
      },
        err => {
          // TODO: redirect to login
          console.log(err);
        });

    this._dataSavedSubscription = this._dataStorageService.dataSaved$.subscribe(
      (res) => {
        if (res) {
          this.showLoader = false;
          this._appLoaderService.hideLoader();
          // redirect after data saved
          if(this.userHasDetails){
            this._router.navigate(["my-account/home"]);
          } else {
            this._router.navigate(['account-details']);
          }
        }
      }
    );

  }

  handleError() {
    this.showLoader = false;
    this._appLoaderService.hideLoader();

    this._errorService.handleCustomInfo({
      text: 'Something went wrong!',
      type: 'info'
    });
  }

  redirectUser() {
    const userLoggedIn = this.getState(this._appStore).userReducer.userDetails.userLoggedIn;
    /**
     * if otp is expired or invalid redirect user to @access-options with @email
     * if OTP is valid submit otp and redirect user to @home screen
     */
    if (this._tokenStoreData.tokenType === '01') {
      this._appStore.dispatch({ type: 'USER_ACCOUNT_UPDATE_STATUS', payload: true });

      const user = this.getState(this._appStore).userReducer;
      if (user.userDetails.userEmailTokenValid && Object.keys(user.userDetails.userEmailToken).length !== 0) {
        this._router.navigate(['set-password']);
      } else {
        this._router.navigate(['account-details']);
      }
    } else if (this._tokenStoreData.tokenType === '02') {
      const url = environment.trackUrl + '?bookingref='
        + this._tokenStoreData.bookingReference
        + '&email=' + this._tokenStoreData.emailAddress !== null
          ? this._tokenStoreData.emailAddress : '';

      window.location.replace(url+'&referrer=bookingFunnel');
    } else if (this._tokenStoreData.tokenType === '03') {
      if (!userLoggedIn) {
        this._router.navigate(['login'],
        { queryParams: { redirect: 'my-account/bookings/booking-details', ref: this._tokenStoreData.bookingReference }});
      } else {
        this._router.navigate(['my-account/bookings/booking-details'], { queryParams: { ref: this._tokenStoreData.bookingReference }});
      }

    // magic link
    } else if (this._tokenStoreData.tokenType === '06') {

      // if magic link valid, login
      if (this._tokenStoreData) {
        const storeCookie = true;
        const isGuest = false;

        const token = this._tokenStoreData.accessToken;
        const parsedToken = this.parseReturnedData(token);

        this._loginService.loginAccessToken(parsedToken.access_token, storeCookie, isGuest);

        this._appStore.dispatch({ type: 'UPDATE_USER_SHOW_TOAST', payload: true });
      }

      setTimeout(() => {
        // redirect with session data
        this._router.routeReuseStrategy.shouldReuseRoute = function(){ return false; };
        const currentUrl = this._router.url;
        this._router.navigateByUrl(currentUrl)
          .then(() => {
            this._router.navigated = false;
            window.open('flight-finder/search?session=' + this._sessionId, '_self');
          });
      }, 1500);
    }

  }

  loginUserWithOtpResponse(res) {
    const token = res;
    const parsedToken = this.parseReturnedData(token);
    this._appStore.dispatch({ type: 'UPDATE_OTP_VERIFIED', payload: true });
    this._loginService.loginAccessToken(parsedToken.access_token, true, false);
  }

  parseReturnedData(value: any) {
    const parsed = JSON.parse(value);
    return parsed;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    if (this._tokenDataSubscription) { this._tokenDataSubscription.unsubscribe(); }
    if (this._sessionDataSubscription) { this._sessionDataSubscription.unsubscribe(); }
    if (this._verifyEmailSubscription) { this._verifyEmailSubscription.unsubscribe(); }
    if (this._userOTPSubscription) { this._userOTPSubscription.unsubscribe(); }
    if (this._dataSavedSubscription) { this._dataSavedSubscription.unsubscribe(); }
  }

}
